export default "__VITE_ASSET__BcCwGhjn__"